import { Select } from 'antd';
import { useEffect } from 'react';
import { DataSelectBox } from '../../models/selectbox';

const DiemPheDuyetSelectBox = ({ value, disabled, diemChuyenMon, onChange }: { value: number, disabled?: boolean, diemChuyenMon: number, onChange: (e: any) => void }) => {
    const data: Array<DataSelectBox> = [
        ...(diemChuyenMon >= 70
            ? [
                {
                    value: 1,
                    label: "A+",
                },
            ]
            : []),
        {
            value: 2,
            label: "A"
        },
        {
            value: 3,
            label: "B"
        },
        {
            value: 4,
            label: "C"
        },
    ];

    useEffect(() => {
        onChange({
            target: {
                value: value
            }
        })
    }, []);

    return (
        <Select
            style={{ width: '70px', marginLeft: "15px" }}
            value={value}
            options={data}
            onChange={(e: number) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
            disabled={disabled}
        />
    );
};

export default DiemPheDuyetSelectBox;
